import { SearchDomainConfigProviderContext } from './SearchDomainConfigProvider.context.ts';

export const SearchDomainConfigProvider = SearchDomainConfigProviderContext.Provider;
